import { BACKEND_BASE_URL } from '../services/api';

/** A beépített Portero jel, ha a klub nem töltött fel saját címert. */
export const DEFAULT_LOGO_SRC = '/logo.svg';

/**
 * A fejlécben, a bejelentkező képernyőn és a menüben megjelenő embléma: a klub
 * feltöltött címere, vagy ennek híján a beépített logó. Egy helyen, hogy a
 * tartalék mindenhol ugyanaz legyen.
 */
export const clubLogoSrc = (crestUrl?: string | null): string =>
  crestUrl ? `${BACKEND_BASE_URL}${crestUrl}` : DEFAULT_LOGO_SRC;

/**
 * Ha a feltöltött címer nem tölthető be (törölt fájl, elérhetetlen backend),
 * a beépített logóra váltunk - üres helyet ne hagyjunk. A csere egyszeri: ha a
 * tartalék sem jön be, nem próbálkozunk tovább.
 */
export const handleClubLogoError = (event: React.SyntheticEvent<HTMLImageElement>): void => {
  const img = event.currentTarget;
  if (img.src.endsWith(DEFAULT_LOGO_SRC)) {
    img.style.display = 'none';
    return;
  }

  img.src = DEFAULT_LOGO_SRC;
};
